import Header from "../Layouts/Header";
import NavBar from "../Layouts/NavBar";
import React, {useEffect} from "react";
import FooterWoman from "../Components/FooterWoman";
import ServicesWoman from "../Layouts/ServicesWoman";
import ImageDivider from "../Components/ImageDivider";
import LocationAndServicesWoman from "../Layouts/LocationAndServicesWoman";
import Product from "../Layouts/Product";
import Carousel from "../Components/Carousel";


function Woman({onSwitch}: {onSwitch: () => void}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header background={"bg-header-background-woman"} link={"https://tribeauty.it/MR.TREWAN"}
              logo={"bg-logo-white-woman"} woman={true}/>
      <ServicesWoman/>
      <ImageDivider
        headerTextColor={"accentWoman"}
        background={"bg-sfondo-locale-woman"}
        header=" Innovativo. Elegante. Emozionante."
        texts={[
          " Mr.Trewan Elite Hair Spa nasce da un sogno scolpito e modellato attorno al concetto di lusso e benessere più completo.",
          "ESCLUSIVO PER NATURA",
          "UNICO PER SCELTA"
        ]}
      />
      <LocationAndServicesWoman/>
      <div className="py-12 w-full h-full bg-accentWoman">
        <Carousel images={[
          'bg-foto-servizi-2-woman',
          'bg-foto-servizi-3-woman',
          'bg-foto-servizi-4-woman',
          'bg-foto-servizi-5-woman',
          'bg-foto-servizi-7-woman',
          'bg-foto-servizi-9-woman',
          'bg-foto-servizi-10-woman',
          'bg-foto-servizi-11-woman',

        ]}/>
      </div>
      <Product background={"white"}/>
      <div className="py-12 w-full h-full bg-accentWoman">
        <Carousel images={[
          'bg-foto-location-2-woman',
          'bg-foto-location-3-woman',
          'bg-foto-location-4-woman',
          'bg-foto-location-5-woman',
          'bg-foto-location-6-woman',
          'bg-foto-location-7-woman',
        ]}/>
      </div>
      <FooterWoman background={"bg-primaryWoman"} headerTextColor={"accentWoman"} logo={"bg-logo-white-woman"}/>
      <NavBar background={"bg-primaryWoman"} logo={"bg-logo-white-woman"} switchLabel="Lui" onSwitch={onSwitch}/>
    </>
  );
}

export default Woman;